<template>
  <div>
    <v-dialog v-model="dialog.filter"
      width="550"
      persistent
      scrollable>
      <v-card 
        class="border-radius pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right">
          <v-avatar size="35">
            <v-img
              contain
              width="30"
              height="30"
              alt="VENOM"
              :src="require('@/assets/logo/venom.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#00ACC1">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="text-capitalize mt-1 ml-1">
            Filter Data
          </span>

          <v-spacer/>

          <v-btn
            fab
            x-small
            elevation="0"
            color="red"
            class="white--text"
            @click="dialog.filter = false">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-divider class="mx-4 my-3"/>

        <v-card-text class="mt-4">
          <v-form>
            <p class="body-1 font-weight-bold text-first mb-1">
              Filter Tanggal Cutoff
            </p>

            <v-row>
              <v-col cols="12" md="6">
                <div>
                  <p class="mb-2">
                    Tanggal Cutoff (Lebih Dari)
                  </p>
                  
                  <v-menu
                    ref="start"
                    min-width="290px"
                    max-width="290px"
                    transition="scale-transition"
                    offset-y
                    :nudge-right="40"
                    :close-on-content-click="false"
                    v-model="search.picker.date.start">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="search.filter.date.start"
                        readonly
                        outlined
                        dense
                        color="#00ACC1"
                        placeholder="Pilih Tanggal Cutoff (Lebih Dari)"
                        hide-details
                        clearable
                        @click:clear="search.filter.date.start = ''; search.filter.date.end = '';"
                        v-on="on">
                      </v-text-field>
                    </template>
                    
                    <v-date-picker 
                      color="#00ACC1"
                      v-model="search.filter.date.start"
                      @input="search.picker.date.start = false"
                      v-on:change="search.filter.date.end = ''">
                    </v-date-picker>
                  </v-menu>
                </div>
              </v-col>

              <v-col cols="12" md="6">
                <div>
                  <p class="mb-2">
                    Tanggal Cutoff (Kurang Dari)
                  </p>
                  
                  <v-menu
                    ref="end"
                    min-width="290px"
                    max-width="290px"
                    transition="scale-transition"
                    offset-y
                    :nudge-right="40"
                    :close-on-content-click="false"
                    v-model="search.picker.date.end">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="search.filter.date.end"
                        readonly
                        outlined
                        dense
                        color="#00ACC1"
                        placeholder="Pilih Tanggal Cutoff (Kurang Dari)"
                        hide-details
                        clearable
                        @click:clear="search.filter.date.end = ''"
                        v-on="on">
                      </v-text-field>
                    </template>
                    
                    <v-date-picker 
                      color="#00ACC1"
                      v-model="search.filter.date.end"
                      :min="search.filter.date.start"
                      @input="search.picker.date.end = false">
                    </v-date-picker>
                  </v-menu>
                </div>
              </v-col>
            </v-row>

            <p class="body-1 font-weight-bold text-first mt-3 mb-1">
              Filter Tanggal Klaim
            </p>

            <v-row>
              <v-col cols="12" md="6">
                <div>
                  <p class="mb-2">
                    Tanggal Klaim (Lebih Dari)
                  </p>
                  
                  <v-menu
                    ref="start"
                    min-width="290px"
                    max-width="290px"
                    transition="scale-transition"
                    offset-y
                    :nudge-right="40"
                    :close-on-content-click="false"
                    v-model="search.picker.claim_datetime.start">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="search.filter.claim_datetime.start"
                        readonly
                        outlined
                        dense
                        color="#00ACC1"
                        placeholder="Pilih Tanggal Klaim (Lebih Dari)"
                        hide-details
                        clearable
                        @click:clear="search.filter.claim_datetime.start = ''; search.filter.claim_datetime.end = '';"
                        v-on="on">
                      </v-text-field>
                    </template>
                    
                    <v-date-picker 
                      color="#00ACC1"
                      v-model="search.filter.claim_datetime.start"
                      @input="search.picker.claim_datetime.start = false"
                      v-on:change="search.filter.claim_datetime.end = ''">
                    </v-date-picker>
                  </v-menu>
                </div>
              </v-col>

              <v-col cols="12" md="6">
                <div>
                  <p class="mb-2">
                    Tanggal Klaim (Kurang Dari)
                  </p>
                  
                  <v-menu
                    ref="end"
                    min-width="290px"
                    max-width="290px"
                    transition="scale-transition"
                    offset-y
                    :nudge-right="40"
                    :close-on-content-click="false"
                    v-model="search.picker.claim_datetime.end">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="search.filter.claim_datetime.end"
                        readonly
                        outlined
                        dense
                        color="#00ACC1"
                        placeholder="Pilih Tanggal Klaim (Kurang Dari)"
                        hide-details
                        clearable
                        @click:clear="search.filter.claim_datetime.end = ''"
                        v-on="on">
                      </v-text-field>
                    </template>
                    
                    <v-date-picker 
                      color="#00ACC1"
                      v-model="search.filter.claim_datetime.end"
                      :min="search.filter.claim_datetime.start"
                      @input="search.picker.claim_datetime.end = false">
                    </v-date-picker>
                  </v-menu>
                </div>
              </v-col>
            </v-row>

            <p class="body-1 font-weight-bold text-first mt-3 mb-1">
              Filter Tanggal Kunjungan
            </p>

            <v-row>
              <v-col cols="12" md="6">
                <div>
                  <p class="mb-2">
                    Tanggal Kunjungan (Lebih Dari)
                  </p>
                  
                  <v-menu
                    ref="start"
                    min-width="290px"
                    max-width="290px"
                    transition="scale-transition"
                    offset-y
                    :nudge-right="40"
                    :close-on-content-click="false"
                    v-model="search.picker.status_datetime.start">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="search.filter.status_datetime.start"
                        readonly
                        outlined
                        dense
                        color="#00ACC1"
                        placeholder="Pilih Tanggal Kunjungan (Lebih Dari)"
                        hide-details
                        clearable
                        @click:clear="search.filter.status_datetime.start = ''; search.filter.status_datetime.end = '';"
                        v-on="on">
                      </v-text-field>
                    </template>
                    
                    <v-date-picker 
                      color="#00ACC1"
                      v-model="search.filter.status_datetime.start"
                      @input="search.picker.status_datetime.start = false"
                      v-on:change="search.filter.status_datetime.end = ''">
                    </v-date-picker>
                  </v-menu>
                </div>
              </v-col>

              <v-col cols="12" md="6">
                <div>
                  <p class="mb-2">
                    Tanggal Kunjungan (Kurang Dari)
                  </p>
                  
                  <v-menu
                    ref="end"
                    min-width="290px"
                    max-width="290px"
                    transition="scale-transition"
                    offset-y
                    :nudge-right="40"
                    :close-on-content-click="false"
                    v-model="search.picker.status_datetime.end">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="search.filter.status_datetime.end"
                        readonly
                        outlined
                        dense
                        color="#00ACC1"
                        placeholder="Pilih Tanggal Kunjungan (Kurang Dari)"
                        hide-details
                        clearable
                        @click:clear="search.filter.status_datetime.end = ''"
                        v-on="on">
                      </v-text-field>
                    </template>
                    
                    <v-date-picker 
                      color="#00ACC1"
                      v-model="search.filter.status_datetime.end"
                      :min="search.filter.status_datetime.start"
                      @input="search.picker.status_datetime.end = false">
                    </v-date-picker>
                  </v-menu>
                </div>
              </v-col>
            </v-row>

            <p class="body-1 font-weight-bold text-first mt-3 mb-1">
              Filter Status
            </p>

            <v-row>
              <v-col cols="12" md="6">
                <div>
                  <p class="mb-2">
                    Status Kunjungan
                  </p>
                  
                  <v-select
                    :items="[
                      {
                        text: 'Semua',
                        value: ''
                      },
                      {
                        text: 'Belum Dikunjungi',
                        value: 'Belum Dikunjungi'
                      },
                      {
                        text: 'Sudah Dikunjungi',
                        value: 'Sudah Dikunjungi'
                      }
                    ]"
                    placeholder="Pilih Status Kunjungan"
                    outlined
                    dense
                    color="#00ACC1"
                    item-text="text"
                    item-value="value"
                    item-color="cyan darken-1"
                    hide-details
                    v-model="search.filter.status">
                  </v-select>
                </div>
              </v-col>

              <v-col cols="12" md="6">
                <div>
                  <p class="mb-2">
                    Status Pembayaran
                  </p>
                  
                  <v-select
                    :items="[
                      {
                        text: 'Semua',
                        value: ''
                      },
                      {
                        text: 'Belum Bayar',
                        value: 'Belum Bayar'
                      },
                      {
                        text: 'Sudah Bayar',
                        value: 'Sudah Bayar'
                      }
                    ]"
                    placeholder="Pilih Status Pembayaran"
                    outlined
                    dense
                    color="#00ACC1"
                    item-text="text"
                    item-value="value"
                    item-color="cyan darken-1"
                    hide-details
                    v-model="search.filter.payment_status">
                  </v-select>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider class="mx-4 my-3"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="#00ACC1"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text"
            @click="dialog.filter = false; fetchAssignment();">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Filter
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.attachment"
      width="1000"
      persistent
      scrollable>
      <v-card 
        class="border-radius pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right">
          <v-avatar size="35">
            <v-img
              contain
              width="30"
              height="30"
              alt="VENOM"
              :src="require('@/assets/logo/venom.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#00ACC1">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="text-capitalize mt-1 ml-1">
            Lampiran
          </span>

          <v-spacer/>

          <v-btn
            fab
            x-small
            elevation="0"
            color="red"
            class="white--text"
            @click="dialog.attachment = false">
            <v-icon>mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-divider class="mx-4 my-3"/>

        <v-card-text class="mt-4">
          <v-img alt="VENOM"
            contain
            :src="selected.attachment">
            <template v-slot:placeholder>
              <v-row
                class="fill-height"
                align="center"
                justify="center">
                <v-progress-circular 
                  indeterminate 
                  color="#00ACC1">
                </v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12" md="3">
        <v-card class="border-radius"
          :flat="rps === 'xs'" 
          :class="rps === 'xs' ? 'mb-6' : 'box-shadow pa-3'">
          <v-card-text v-if="process.load">
            <v-skeleton-loader
              class="ma-auto"
              :loading="process.load"
              type="image, article, article, article">
            </v-skeleton-loader>
          </v-card-text>

          <v-card-text v-else
            class="text-first">
            <div class="mb-4">
              <v-img 
                class="border-radius"
                contain
                alt="VENOM"
                width="100%"
                height="200"
                :src="detail.image_url !== '' ? detail.image_url : require('@/assets/image/member-default.jpg')">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      color="#00ACC1">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </div>

            <div class="body-1 font-weight-bold">
              Informasi Kontak
            </div>

            <v-divider class="my-2" style="border: 2px solid #f0f0f0;"/>

            <div>
              <p class="caption font-weight-light text-second mb-0">
                Nama Lengkap
              </p>

              <p class="body-2 font-weight-light text-capitalize mb-2">
                {{ detail.name }}
              </p>
            </div>

            <div>
              <p class="caption font-weight-light text-second mb-0">
                Email
              </p>

              <p class="body-2 font-weight-light text-capitalize mb-2">
                {{ detail.email }}
              </p>
            </div>

            <div>
              <p class="caption font-weight-light text-second mb-0">
                Telepon
              </p>

              <p class="body-2 font-weight-light text-capitalize">
                {{ detail.mobilephone }}
              </p>
            </div>

            <div class="body-1 font-weight-bold">
              Informasi General
            </div>

            <v-divider class="my-2" style="border: 2px solid #f0f0f0;"/>

            <div>
              <p class="caption font-weight-light text-second mb-0">
                Kode Pengguna
              </p>

              <p class="body-2 font-weight-light text-capitalize mb-2">
                {{ detail.code }}
              </p>
            </div>

            <div>
              <p class="caption font-weight-light text-second mb-0">
                Role (Posisi)
              </p>

              <p class="body-2 font-weight-light text-capitalize mb-2">
                {{ detail.role }} ({{ detail.position }})
              </p>
            </div>

            <div>
              <p class="caption font-weight-light text-second mb-0">
                Lokasi Kantor
              </p>

              <p class="body-2 font-weight-light text-capitalize mb-2">
                {{ detail.office_name }}
              </p>
            </div>

            <div>
              <p class="caption font-weight-light text-second mb-0">
                Status
              </p>

              <p class="body-2 font-weight-light text-capitalize mb-2"
                :class="detail.active_bool ? 'cyan--text text-darken-1' : ''">
                {{ detail.active_bool ? 'Aktif' : 'Tidak Aktif' }}
              </p>
            </div>

            <div>
              <p class="caption font-weight-light text-second mb-0">
                Alamat
              </p>

              <p class="body-2 font-weight-light text-capitalize mb-2">
                {{ detail.address === '' ? '-' : detail.address }}
              </p>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="9">
        <p class="body-1 font-weight-bold mb-1">
          Tugas dari {{ detail.name }}
        </p>

        <p>
          Berikut adalah tugas untuk {{ detail.name }}.
        </p>

        <v-divider class="mb-5" style="border: 2px solid #f0f0f0;"/>

        <v-card flat style="border: 1px solid #E0E0E0;">
          <v-card-text>
            <v-row justify="end">
              <v-col cols="12" md="8">
                <v-btn
                  elevation="0"
                  dark
                  color="#00ACC1"
                  class="body-2 text-capitalize font-weight-bold d-flex align-center"
                  @click="dialog.filter = true">
                  <v-icon size="18">mdi-filter-outline</v-icon>

                  <span class="ml-1">
                    Filter
                  </span>
                </v-btn>
              </v-col>

              <v-col cols="12" md="4" class="d-flex align-center">
                <v-text-field
                  dense
                  single-line
                  hide-details
                  color="#00ACC1"
                  placeholder="Cari . . ."
                  append-icon="mdi-magnify"
                  clearable
                  v-model="search.name"
                  @click:clear="search.name = ''; fetchAssignment();"
                  v-on:keyup.enter="fetchAssignment()">
                </v-text-field>

                <div class="ml-3" v-if="pagination.total_data > 0">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="#00ACC1"
                        elevation="0"
                        min-width="36"
                        class="text-capitalize white--text px-0"
                        :disabled="process.print"
                        :loading="process.print"
                        @click="prints()"
                        v-bind="attrs"
                        v-on="on">
                        <v-icon>mdi-microsoft-excel</v-icon>
                      </v-btn>
                    </template>
                    
                    <span>
                      Print
                    </span>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-data-table
            v-model="selected.row"
            ref="table-grid"
            class="table-grid-assignment text-capitalize"
            :height="`calc(100vh - ${pagination.total_data > 0 ? '383px' : '311px'})`"
            fixed-header
            :loading="process.assignment"
            loading-text="Sedang memuat data . . ."
            loader-height="5"
            no-results-text="Belum ada data"
            :options.sync="options"
            :headers="headers"
            :items="list"
            :items-per-page="100"
            item-key="id"
            @click:row="rowClick" 
            @toggle-select-all="handleToggleAll($event)"
            hide-default-footer>
            <template v-slot:[`item.user_email`]="{ item }">
              <span class="text-lowercase">
                {{ item.user_email }}
              </span>
            </template>
            
            <template v-slot:[`item.date`]="{ item }">
              {{ item.date | date }}
            </template>

            <template v-slot:[`item.claim_datetime`]="{ item }">
              {{ item.claim_datetime | datetime }}
            </template>

            <template v-slot:[`item.status_datetime`]="{ item }">
              {{ item.status_datetime | datetime }}
            </template>

            <template v-slot:[`item.payment_value`]="{ item }">
              {{ item.payment_value | price }}
            </template>

            <template v-slot:[`item.status`]="{ item }">
              <span :class="item.status === 'Belum Dikunjungi' ||  item.status === 'belum dikunjungi' ? 'orange--text' : 'green--text'">
                {{ item.status }}
              </span>
            </template>

            <template v-slot:[`item.payment_status`]="{ item }">
              <span :class="item.payment_status === 'Belum Bayar' || item.payment_status === 'belum bayar' ? 'red--text' : 'blue--text'">
                {{ item.payment_status }}
              </span>
            </template>

            <template v-slot:[`item.attachment`]="{ item }">
              <v-btn v-if="item.attachment !== ''"
                outlined
                small
                color="cyan darken-1"
                class="text-capitalize"
                @click="dialog.attachment = true; selected.attachment = item.attachment;">
                <v-icon small class="mr-1">mdi-eye-outline</v-icon>
                Lampiran
              </v-btn>
            </template>
          </v-data-table>

          <pagination v-if="pagination.total_data > 0"
            @changePage="fetchAssignment($event)" 
            @reloadPage="fetch($event)"
            :model="pagination"/>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../../service/Axios";
  import { TokenService } from "../../../service/Storage.Service";
  import axios from "axios";
  import moment from "moment";
  export default {
    data () {
      return {
        dialog: {
          filter: false,
          attachment: false
        },
        search: {
          name: '',
          filter: {
            date: {
              start: '',
              end: ''
            },
            claim_datetime: {
              start: '',
              end: ''
            },
            status_datetime: {
              start: '',
              end: ''
            },
            status: '',
            payment_status: ''
          },
          picker: {
            date: {
              start: false,
              end: false
            },
            claim_datetime: {
              start: false,
              end: false
            },
            status_datetime: {
              start: false,
              end: false
            }
          }
        },
        selected: {
          row: [],
          attachment: ''
        },
        options: {},
        detail: {},
        headers: [],
        list: [],
        pagination: {},
        limit: 20,
        process: {
          load: false,
          assignment: false,
          print: false
        },
        message: {
          error: '',
          success: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      }
    },
    watch: {
      options: {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          this.fetchAssignment(pagination)
        },
        deep: true
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      handleToggleAll(event) {
        if (!event.value) this.selected.row = []
      },
      fetch() {
        this.fetchUser()
        this.fetchAssignment()
      },
      async fetchUser() {
        this.process.load = true

        let params = {
          'id[eq]': this.$route.params.id
        }

        await get(`admin/user`, { params }).then(response => {
          let res = response.data

          this.process.load = false

          if (res.status === 200) {
            this.detail = res.results.data[0]
          }
        })
      },
      async fetchAssignment(pagination = { row: 20, page: 1 }) {
        this.process.assignment = true

        this.limit = pagination.row

        let SORT = this.options.sortBy.length < 1 ? '-id' : this.options.sortDesc[0] ? `-${this.options.sortBy[0]}` : this.options.sortBy[0]

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: SORT,
          search: this.search.name,
          'user_id[eq]': this.$route.params.id,
          'date[gte]': this.search.filter.date.start,
          'date[lte]': this.search.filter.date.end,
          'claim_datetime[gte]': this.search.filter.claim_datetime.start,
          'claim_datetime[lte]': this.search.filter.claim_datetime.end,
          'status_datetime[gte]': this.search.filter.status_datetime.start,
          'status_datetime[lte]': this.search.filter.status_datetime.start,
          'status[lse]': this.search.filter.status,
          'payment_status[lse]': this.search.filter.payment_status,
        }

        await get(`admin/task`, { params }).then(response => {
          let res = response.data

          this.process.assignment = false

          if (res.status === 200) {
            this.headers = [
              {
                text: 'Kode',
                width: '100px',
                value: 'participant_code'
              },
              {
                text: 'Nama Peserta',
                width: '200px',
                value: 'participant_name'
              },
              {
                text: 'Telepon Peserta',
                width: '150px',
                value: 'participant_mobilephone'
              },
              {
                text: 'Nama Petugas',
                width: '200px',
                value: 'user_name'
              },
              {
                text: 'Email Petugas',
                width: '175px',
                value: 'user_email'
              },
              {
                text: 'Telepon Petugas',
                width: '150px',
                value: 'user_mobilephone'
              },
              {
                text: 'Tanggal Cutoff',
                width: '150px',
                value: 'date'
              },
              {
                text: 'Tanggal Klaim',
                width: '175px',
                value: 'claim_datetime'
              },
              {
                text: 'Status Kunjungan',
                width: '175px',
                value: 'status'
              },
              {
                text: 'Tanggal Kunjungan',
                width: '175px',
                value: 'status_datetime'
              },
              {
                text: 'Status Pembayaran',
                width: '175px',
                value: 'payment_status'
              },
              {
                text: 'Nominal Pembayaran',
                width: '175px',
                value: 'payment_value',
                align: 'end'
              },
              {
                text: 'Lampiran',
                width: '100px',
                value: 'attachment'
              }
            ]
            
            this.list = res.results.data
            this.pagination = res.results.pagination

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })
          }
        })
      },
      async prints () {
        this.message.error = ''

        this.process.print = true

        let SORT = this.options.sortBy.length < 1 ? '-id' : this.options.sortDesc[0] ? `-${this.options.sortBy[0]}` : this.options.sortBy[0]

        let params = {
          sort: SORT,
          search: this.search.name,
          'user_id[eq]': this.$route.params.id,
          'date[gte]': this.search.filter.date.start,
          'date[lte]': this.search.filter.date.end,
          'claim_datetime[gte]': this.search.filter.claim_datetime.start,
          'claim_datetime[lte]': this.search.filter.claim_datetime.end,
          'status_datetime[gte]': this.search.filter.status_datetime.start,
          'status_datetime[lte]': this.search.filter.status_datetime.start,
          'status[lse]': this.search.filter.status,
          'payment_status[lse]': this.search.filter.payment_status,
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}admin/task/export`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response
          if (res.status === 200) {
            this.process.print = false
            
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport excel'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `AMJ-PENUGASAN-${moment().format('DD-MMMM-YYYY', 'id')}.xls`)
            document.body.appendChild(link)
            link.click()
          } else {
            this.process.print = false
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>

<style>
  .table-grid-assignment table > thead > tr > th:nth-child(1) {
    position: sticky !important; 
    position: -webkit-sticky !important; 
    left: 0; 
    z-index: 5 !important;
    background: white;
  }
  .table-grid-assignment table > thead > tr > th:nth-child(2) {
    position: sticky !important; 
    position: -webkit-sticky !important; 
    left: 100px; 
    z-index: 5 !important;
    background: white;
  }
  .table-grid-assignment table > tbody > tr > td:nth-child(1) {
    position: sticky !important; 
    position: -webkit-sticky !important; 
    left: 0; 
    z-index: 1;
    background: white;
  }
  .table-grid-assignment table > tbody > tr > td:nth-child(2) {
    position: sticky !important; 
    position: -webkit-sticky !important; 
    left: 100px; 
    z-index: 1;
    background: white;
  }
</style>